import React from "react"

import { ContainerWrapper, ButtonContainer } from './styles'
import Button from "../../components/Button";
import { Link } from 'react-router-dom';


function BeARetailer() {

    return(
        <>
            <ContainerWrapper>
                <div className="header-style">
                    <h1>Seja um Revendedor</h1>
                    <p className="sub-title">Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                    accusantium doloremque laudantium, totam rem aperiam, eaque
                    natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam</p>
                </div>
                <div className="text-container">
                    <h1>Passo 1:</h1>
                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                    accusantium doloremque laudantium, totam rem aperiam, eaque
                    natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                    accusantium doloremque laudantium, totam rem aperiam, eaque
                    natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam</p>
                    <h1>Passo 2:</h1>
                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                    accusantium doloremque laudantium, totam rem aperiam, eaque
                    natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam</p>
                </div>
            </ContainerWrapper>
            <ButtonContainer>
                <Link to='/retailer/create'>
                    <Button format="submit">Vire um revendedor agora</Button>
                </Link>
            </ButtonContainer>
        </>
    )
}

export default BeARetailer